// plugins/loginModal.js
import Vue from 'vue'
import LoginModal from "@/components/dialog/loginDialog"


const LoginModalConstructor = Vue.extend(LoginModal)

let loginModalInstance = null

const initInstance = () => {
    loginModalInstance = new LoginModalConstructor({
        el: document.createElement('div')
    })
    document.body.appendChild(loginModalInstance.$el)
}

const LoginModalPlugin = {}

LoginModalPlugin.install = function (Vue) {
    Vue.prototype.$login = function (options = {}) {
        if (!loginModalInstance) {
            initInstance()
        }
        // 将store方法传递给组件
        loginModalInstance.$store = this.$store
        // loginModalInstance.$router = options.router

        
        return loginModalInstance.open(options)
    }
}

export default LoginModalPlugin
// plugins/loginDialog.js
// import Vue from 'vue'
// import LoginDialog from "@/components/dialog/loginDialog"

// const LoginDialogPlugin = {
//   install(Vue, options) {
//     // 使用Vue.extend创建组件构造函数
//     const LoginDialogConstructor = Vue.extend(LoginDialog)
    
//     // 创建组件实例
//     const instance = new LoginDialogConstructor({
//       // 传递store和router，确保组件内能访问到
//       store: options.store,
//       router: options.router
//     })
    
//     // 手动挂载到新创建的div元素上
//     instance.$mount(document.createElement('div'))
//     // 将生成的DOM元素添加到body
//     document.body.appendChild(instance.$el)
    
//     // 在Vue原型上添加$loginDialog方法，方便全局调用
//     Vue.prototype.$loginDialog = {
//       open: () => instance.open(),
//       close: () => instance.close()
//     }
//   }
// }

// export default LoginDialogPlugin
